import { Text } from '@mantine/core';
import { Navigate } from 'react-router-dom';

import { MainLayout } from '@/components';
import { RequirePermission } from '@/components/RequirePermission';
import { getEnabledNavRoutes } from '@/config/navigation';

export const protectedRoutes = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: (
          <Text c="dimmed" ta="center" mt="xl">
            Select a section from the menu
          </Text>
        ),
      },
      ...getEnabledNavRoutes().map(({ path, element, permission }) => ({
        path,
        element: <RequirePermission permission={permission}>{element}</RequirePermission>,
      })),
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
];
